import { render, staticRenderFns } from "./UserScreen.vue?vue&type=template&id=6c3b04f1&scoped=true"
import script from "./UserScreen.vue?vue&type=script&lang=js"
export * from "./UserScreen.vue?vue&type=script&lang=js"
import style0 from "./UserScreen.vue?vue&type=style&index=0&id=6c3b04f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b04f1",
  null
  
)

export default component.exports